import React from "react";
import { InfoIcon, InfoPopover, Odds } from "@picklebet/ui";
import type { OddsProps } from "@picklebet/ui";
import { Link } from "@/features/shell/components/shared/Link/Link";
import { removeTrailingSlash } from "@/utilities/strings";

import * as styles from "./BetOddsWithDeductions.module.scss";

type BetOddsWithDeductionsProps = {
  deductions?: number | null;
  deadHeatFactor?: number | null;
  isVoid?: boolean;
  pickUrl?: string;
} & OddsProps;

const BetOddsWithDeductions = ({
  deductions,
  deadHeatFactor,
  isVoid,
  ...props
}: BetOddsWithDeductionsProps) => {
  const hasDeadHeat = deadHeatFactor && deadHeatFactor !== 1;
  const hasDeductions = !!deductions;
  const hasDeductionsOrDeadHeat = hasDeadHeat || hasDeductions;

  const pickUrl = removeTrailingSlash(props.pickUrl);

  return (
    <div className={styles.container} onClick={(e) => e.stopPropagation()}>
      <Odds isVoid={isVoid} {...props} />
      <span className={styles.deductions}>
        {hasDeductionsOrDeadHeat && !isVoid && (
          <InfoPopover
            content={
              <div className={styles.content}>
                {hasDeadHeat && (
                  <span>
                    {(100 - deadHeatFactor * 100).toFixed(2)}% Odds reduction
                    due to a{" "}
                    <Link className="green-link" to={`${pickUrl}/win-place`}>
                      Dead Heat
                    </Link>
                  </span>
                )}
                {hasDeductions && (
                  <span>
                    {(deductions * 100).toFixed(2)}% Odds reduction due to{" "}
                    <Link className="green-link" to={`${pickUrl}/deductions`}>
                      Deductions
                    </Link>
                  </span>
                )}
              </div>
            }
          >
            <div className={styles.info}>
              <InfoIcon />
            </div>
          </InfoPopover>
        )}
      </span>
    </div>
  );
};

export { BetOddsWithDeductions };
